import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, API } from "@/lib/api";
import { card, btnPrimary } from "../ui";
import { Upload, Trash2, FileText, Download, Loader2 } from "lucide-react";

const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);

export default function Attachments({ patientId }) {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get(`/patients/${patientId}/attachments`).then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, [patientId]);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post(`/patients/${patientId}/attachments`, fd);
      toast.success("Anexo enviado.");
      load();
    } catch { toast.error("Erro ao enviar o arquivo."); }
    finally { setUploading(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const del = async (aid) => {
    if (!window.confirm("Excluir este anexo?")) return;
    await api.delete(`/attachments/${aid}`);
    toast.success("Anexo excluído.");
    load();
  };

  return (
    <div className="space-y-6">
      <div className={`${card} p-6 flex flex-wrap items-center justify-between gap-4`}>
        <div>
          <p className="font-display text-lg text-[#2C332A]">Anexos do paciente</p>
          <p className="font-body text-sm text-[#7A8A7A]">PDFs, exames, imagens e documentos.</p>
        </div>
        <input ref={fileRef} type="file" className="hidden" onChange={onFile} data-testid="attachment-input" />
        <button className={btnPrimary} onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="attachment-upload">
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Enviar arquivo
        </button>
      </div>

      <div className="grid gap-3 sm:grid-cols-2" data-testid="attachment-list">
        {items.length === 0 && <p className="font-body text-sm text-[#7A8A7A]">Nenhum anexo ainda.</p>}
        {items.map((a) => (
          <div key={a.id} className={`${card} p-4 flex items-center gap-3`} data-testid="attachment-item">
            <div className="grid place-items-center w-10 h-10 rounded-lg bg-[#F5F0E6] shrink-0"><FileText className="w-5 h-5 text-[#5B6E5B]" /></div>
            <div className="min-w-0 flex-1">
              <p className="font-body text-sm text-[#2C332A] truncate">{a.filename}</p>
              <p className="font-body text-xs text-[#A8B0A2]">{fmtSize(a.size || 0)}</p>
            </div>
            <a href={`${API}/attachments/${a.id}/download`} target="_blank" rel="noreferrer" className="text-[#5B6E5B] hover:text-[#2C332A]" data-testid="attachment-download" title="Abrir / baixar"><Download className="w-4 h-4" /></a>
            <button onClick={() => del(a.id)} className="text-[#C87A5E] hover:text-[#B2644D]" data-testid="attachment-delete"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
